<template>
  <div class="d-flex flex-column">
    <div class="card mb-30">
      <header class="card-header">
        <h4 class="mt-2">
          Questions
        </h4>
      </header>
      <div class="card-body">
        <button
          v-if="!isActive"
          class="btn btn-primary mb-3"
          @click="isEditable = true;"
        >
          EDIT
        </button>
        <div
          v-for="(question, qi) in questions"
          :key="qi"
          class="form-group row align-items-center"
        >
          <label
            for="campaign_name"
            class="col-sm-2 text-right mb-3"
          >
            Question {{ qi + 1 }}
          </label>
          <div class="form-group__control col-sm-8 mb-3">
            <input
              v-model="question.question"
              :readonly="!isActive"
              type="text"
              class="form-control"
              placeholder="Enter a question"
              minlength="4"
              maxlength="255"
            >
          </div>
          <div class="form-group__control col-sm-2 mb-3">
            <button
              v-if="isActive"
              class="btn btn-primary"
              @click="questions.splice(qi, 1)"
            >
              <img
                src="../../../assets/img/trash-2-xxl.png"
                width="16"
                alt=""
                class="pb-1"
              >
            </button>
          </div>
          <label
            for="campaign_name"
            class="col-sm-4 text-right mb-3"
          >
            Options
          </label>
          <template v-for="(option, oi) in question.options">
            <div
              :key="oi + 'x'"
              class="form-group__control col-sm-6 mb-3"
              :class="oi !== 0 ? 'offset-sm-4' : ''"
            >
              <input
                v-model="question.options[oi]"
                :readonly="!isActive"

                type="text"
                class="form-control"
                placeholder="Enter an option"
                minlength="4"
                maxlength="255"
              >
            </div>
            <div
              v-if="question.options.length > 1"
              :key="oi"
              class="form-group__control col-sm-2 mb-3"
            >
              <button
                v-if="isActive"
                class="btn btn-primary"
                @click="question.options.splice(oi, 1)"
              >
                <img
                  src="../../../assets/img/trash-2-xxl.png"
                  width="16"
                  alt=""
                  class="pb-1"
                >
              </button>
            </div>
          </template>
          <div class="col-sm-8 offset-sm-4 mb-4">
            <button
              v-if="isActive"
              class="btn btn-primary"
              @click="question.options.push('')"
            >
              ADD OPTION
            </button>
          </div>
        </div>
        <button
          v-if="isActive"
          class="btn btn-primary"
          @click="questions.push({question: '',options: ['']})"
        >
          ADD QUESTION
        </button>
        <br>
      </div>
    </div>
    <button
      class="btn btn-primary ml-auto my-3"
      @click="$emit('input', questions); $emit('submitted', null)"
    >
      SUBMIT
    </button>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Array,
      required: true,
    },
    isSubmitted: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      questions: [],
      isEditable: false,
    };
  },
  computed: {
    isActive() {
      return !this.isSubmitted || this.isEditable;
    },
  },
  created() {
    this.questions = this.value ? this.value : [];
  },
};
</script>
<style scoped>

</style>
